import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify"; // Import toast

// Use the environment variable for the API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddAdjustmentCategory() {
  const [adjustmentCategoryName, setAdjustmentCategoryName] = useState("");
  const [generatedAdjustmentCategoryCode, setGeneratedAdjustmentCategoryCode] = useState(null); // State to hold the generated unit code
  const [movementType, setMovementType] = useState("");

  const token = localStorage.getItem("token");

  if(!token) {
    toast.error("No token found. Please log in");
    return;
  }

  const organizationId = localStorage.getItem("organization_id");

// Handle form submission
const handleAddCategory = async () => {
  if (!adjustmentCategoryName) {
    toast.error("Category name is required.");
    return;
  }

  try {
    const response = await axios.post(
      `${API_BASE_URL}/adjustmentTypes/add`,
      { adjustment_category_name: adjustmentCategoryName,
        organization: organizationId,
        stock_movement_type: movementType
       }, // Send as JSON
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const { message, category } = response.data;
    toast.success(message || "Adjustment Category added successfully!"); // Display success toast

    // Set the generated unit code from the response
    setGeneratedAdjustmentCategoryCode(category.category_code);

    setTimeout(() => {  
      setAdjustmentCategoryName("");
      setGeneratedAdjustmentCategoryCode(null);
    }, 1000);

  } catch (error) {
    console.error("Error adding Adjustment Category:", error);

    if (error.response && error.response.status === 400) {
      const errorMessage = error.response.data.message;
      if (errorMessage === "Category name already exists.") {
        toast.error("This category already exists in the organization.");
      } else {
        toast.error(errorMessage || "Error adding Location Category. Please try again.");
      }
    } else {
      toast.error("Error adding Adjustment Category. Please try again.");
    }
  }
};
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <div>
          <h2 className="text-2xl font-bold text-green-700 mb-6">Add Adjustment Category</h2>
          {/* Left Column */}
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">Category Name</label>
              <input
                type="text"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                placeholder="Enter category name"
                value={adjustmentCategoryName}
                onChange={(e) => setAdjustmentCategoryName(e.target.value)}
              />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700 mb-2">Stock Movement Type</label>
                <select
                    value={movementType}
                    onChange={(e) => setMovementType(e.target.value)} // Update state on change
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                    <option value="">Select Movement Type</option>
                    <option value="Add">Addition</option>
                    <option value="Remove">Removal</option>
                </select>
                </div>
          </div>
          {/* Display the generated organization code if available */}
          {generatedAdjustmentCategoryCode && (
            <div className="mt-4 p-4 bg-gray-100 rounded-lg">
              <p className="text-green-700 font-bold">
                Generated Product Category Code: {generatedAdjustmentCategoryCode}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="flex space-x-4 mt-6">
        <button
          className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
          onClick={handleAddCategory}
        >
          Add Adjustment Category
        </button>
      </div>
    </div>
  );
}

export default AddAdjustmentCategory;
